import apiSkobo from "@/helpers/api/apiSkobo";

export const people_actions = {
  async cprSearch(cprId) {
    const response = await apiSkobo.get(`/SsnSearch?cpr=${cprId}`);

    this.peopleCpr = response.data;

    return response.data;
  }
};

export const peolpe_getters = {};

export const people_state = {
  peopleCpr: null
};
